export const soundConfig = {
    tournamentStart: {
        tabKey: 'display.settingsTabTournamentStart',
        titleKey: 'display.tournamentStartActionsTitle',
        soundId: 'tournament_start_sound',
        configKey: 'lastSelectedTournamentStartSoundId',
    },
    levelStart: {
        tabKey: 'display.settingsTabLevelStart',
        titleKey: 'levelStartActionsTitle',
        soundId: 'level_start_sound',
        configKey: 'lastSelectedLevelStartSoundId',
    },
    breakStart: {
        tabKey: 'display.settingsTabBreakStart',
        titleKey: 'breakStartActionsTitle',
        soundId: 'break_start_sound',
        configKey: 'lastSelectedBreakStartSoundId',
    },
    levelEndWarning: {
        tabKey: 'display.settingsTabLevelEndWarning',
        titleKey: 'levelEndWarningActionsTitle',
        soundId: 'level_end_warning_sound',
        configKey: 'lastSelectedLevelEndWarningSoundId',
    },
};